
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.826 4.18v-.402c0-1.618-1.504-2.846-3.082-2.432-.95-1.837-3.491-1.76-4.378.028-1.532-.392-3.058.776-3.058 2.411v4.68a2.43 2.43 0 00-2.304.33 2.503 2.503 0 00-.54 3.457l4.452 6.25a1.187 1.187 0 00.967.498h8.272c.553 0 1.033-.382 1.157-.92l1.12-4.86a7.557 7.557 0 00.193-1.695V6.643c0-1.508-1.318-2.672-2.8-2.463zm1.018 7.345c0 .435-.05.87-.148 1.294l-1.014 4.4H6.19l-4.275-6c-.535-.753.558-1.588 1.091-.84l1.007 1.414c.334.468 1.077.233 1.077-.345V3.785c0-.952 1.357-.92 1.357.026V9.5c0 .328.266.594.594.594h.255a.594.594 0 00.593-.594V2.486c0-.952 1.357-.92 1.357.026V9.5c0 .328.266.594.594.594h.255a.594.594 0 00.593-.594V3.753c0-.953 1.357-.921 1.357.025V9.5c0 .328.266.594.594.594h.255a.594.594 0 00.593-.594V6.668c0-.974 1.357-.951 1.357-.025v4.882z","fill":"currentColor"}})])
          )
        }
      }
    